export enum DescriptionType {
    ORIGINAL_SCORE = 5,
    OVERALL_SCORE,
    ADJUSTED_SCORE,
}
